export class WebhookV1StandardPayloadSnapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadSnapshotTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadSnapshotArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadSnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadSnapshotTypeEnum;
(function (WebhookV1StandardPayloadSnapshotTypeEnum) {
    WebhookV1StandardPayloadSnapshotTypeEnum["RansomwareDetectedInSnapshot"] = "RANSOMWARE_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadSnapshotTypeEnum["MalwareDetectedInSnapshot"] = "MALWARE_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadSnapshotTypeEnum["DataAnomalyDetectedInSnapshot"] = "DATA_ANOMALY_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadSnapshotTypeEnum["AiDataRiskDetectedInSnapshot"] = "AI_DATA_RISK_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadSnapshotTypeEnum["DataExposureRiskDetectedInSnapshot"] = "DATA_EXPOSURE_RISK_DETECTED_IN_SNAPSHOT";
})(WebhookV1StandardPayloadSnapshotTypeEnum || (WebhookV1StandardPayloadSnapshotTypeEnum = {}));
